import React from 'react';
import PropTypes from 'prop-types';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import ScenarioSelectionRedefinedSectionMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ScenarioSelectionRedefinedSectionMetaOverride';
import ProposalProjectionSectionLayout from './ProposalProjectionSectionLayout';

export const ProposalProjectionSection = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={ProposalProjectionSectionLayout}
      resource={resource}
      metaOverrideSet={ScenarioSelectionRedefinedSectionMetaOverride}
    />
  );
};

ProposalProjectionSection.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ProposalProjectionSection;
